export const WAITING = "WAITING";
export const WAITING_DRYING = "WAITING_DRYING";
export const WAITING_APPOINTMENT = "WAITING_APPOINTMENT";
export const MISSING_PARTS = "MISSING_PARTS";
export const specialWaitings = [
  WAITING_DRYING,
  WAITING_APPOINTMENT,
  MISSING_PARTS
];

export const getMessages = ({ description, t, providerName, relevantData }) => {
  switch (description) {
    case WAITING_APPOINTMENT:
      return {
        title: t("waiting_appointment_card-title"),
        message: t("waiting_appointment_card-text_1"),
        historyMessage: t("history-waiting_appointment_card-text", relevantData)
      };
    case WAITING_DRYING:
      return {
        title: t("waiting_drying_card-title"),
        message: t("waiting_drying_card-text_1"),
        historyMessage: t("history-waiting_drying_card-text", relevantData)
      };
    case MISSING_PARTS:
      return {
        title: t("missing_parts_card-title"),
        message: `${t("missing_parts_card-text_1")} ${providerName} ${t(
          "missing_parts_card-text_2"
        )}`,
        historyMessage: t("history-missing_parts_card-text", relevantData)
      };
    default:
      return {
        title: t("waiting_card-title"),
        message: t("waiting_card-text_1"),
        historyMessage: t("history-waiting_card-text", relevantData)
      };
  }
};
